import React from "react";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminHcpcsCodeGeneral extends CardClass {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: !!props.hcpcsCode, // Initialize based on whether hcpcsCode is provided
        };
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={3}>
                    <MUITextField
                        value={this.props.hcpcsCode?.code || ""}
                        autoFocus={true}
                        size="small"
                        label="Code"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 5,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ code: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ code: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.code ? true : false}
                        helperText={this.props.validationIssues.code ? this.props.validationIssues.code : ""}
                        disabled={this.state.isEditing} // Use local state to control disabled state
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={12} md={12}>
                    <MUITextField
                        value={this.props.hcpcsCode?.descriptionLong || ""}
                        size="small"
                        label="Long Description"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 1024,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ descriptionLong: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ descriptionLong: e.target.value })}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={12} md={12}>
                    <MUITextField
                        value={this.props.hcpcsCode?.descriptionShort || ""}
                        size="small"
                        label="Short Description"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 225,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ descriptionShort: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ descriptionShort: e.target.value })}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "General";
    }
}